export const ITEM_ID_KEY = 'ItemId';
export const SUBJECT_KEY = 'Subject';
export const START_KEY = 'Start';
export const END_KEY = 'End';
export const IS_ALLDAY_EVENT_KEY = 'IsAllDayEvent';
export const IS_ROOM_REQUESTED_KEY = 'IsRoomRequested';
export const REMINDER_MINUTES_BEFORE_START_KEY = 'ReminderMinutesBeforeStart';
export const REMINDER_IS_SET_KEY = 'ReminderIsSet';
export const CHARM_KEY = 'CharmId';
export const RECURRENCE_KEY = 'Recurrence';
export const PARENT_FOLDER_ID_KEY = 'ParentFolderId';
export const LOCATIONS_KEY = 'Locations';
export const FREE_BUSY_TYPE_KEY = 'FreeBusyType';
export const SENSITIVITY_KEY = 'Sensitivity';
export const REQUIRED_ATTENDEES_KEY = 'RequiredAttendees';
export const OPTIONAL_ATTENDEES_KEY = 'OptionalAttendees';
export const RESOURCES_KEY = 'Resources';
export const INBOX_REMINDERS_KEY = 'InboxReminders';
export const CATEGORIES_KEY = 'Categories';
export const START_TIME_ZONE_ID_KEY = 'StartTimeZoneId';
export const END_TIME_ZONE_ID_KEY = 'EndTimeZoneId';
export const IS_ONLINE_MEETING = 'IsOnlineMeeting';
export const ONLINE_MEETING_PROVIDER = 'OnlineMeetingProvider';

const calendarItemPropertyKeys = {
    ItemId: ITEM_ID_KEY,
    Start: START_KEY,
    Subject: SUBJECT_KEY,
    End: END_KEY,
    IsAllDayEvent: IS_ALLDAY_EVENT_KEY,
    IsRoomRequested: IS_ROOM_REQUESTED_KEY,
    ReminderMinutesBeforeStart: REMINDER_MINUTES_BEFORE_START_KEY,
    ReminderIsSet: REMINDER_IS_SET_KEY,
    CharmId: CHARM_KEY,
    Recurrence: RECURRENCE_KEY,
    ParentFolderId: PARENT_FOLDER_ID_KEY,
    Locations: LOCATIONS_KEY,
    FreeBusyType: FREE_BUSY_TYPE_KEY,
    Sensitivity: SENSITIVITY_KEY,
    RequiredAttendees: REQUIRED_ATTENDEES_KEY,
    OptionalAttendees: OPTIONAL_ATTENDEES_KEY,
    Resources: RESOURCES_KEY,
    InboxReminders: INBOX_REMINDERS_KEY,
    Categories: CATEGORIES_KEY,
    StartTimeZoneId: START_TIME_ZONE_ID_KEY,
    EndTimeZoneId: END_TIME_ZONE_ID_KEY,
    IsOnlineMeeting: IS_ONLINE_MEETING,
    OnlineMeetingProvider: ONLINE_MEETING_PROVIDER,
};

export default calendarItemPropertyKeys;
